export default __webpack_public_path__ + "static/media/Mindset.3dbb28ae.svg";